import { render, staticRenderFns } from "./WillBeneficiariesStateBenefitsYN.vue?vue&type=template&id=4c467da6"
import script from "./WillBeneficiariesStateBenefitsYN.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesStateBenefitsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports